import 'selectric'
import GLightbox from 'glightbox'
import './components/tabs.js'
// import 'owl.carousel'

(function ($) {
	'use strict';

	// ===============================================================================
	// INIT
	// ===============================================================================

	/* GLightbox
	*******************************************************************************/
	function runGlightbox() {
		const lightbox = GLightbox({
			autoplayVideos: true,
			loop: true
		});
	}
	runGlightbox();

	// ===============================================================================
	// GLOBAL
	// ===============================================================================

	/* Responsive menu / lance animations
	*******************************************************************************/
	$(window).on('load resize', function (event, newSize, oldSize) {
		// Menu
		if ($('.js-menu').length && window.matchMedia('(min-width: 1024px)').matches) {
			$('.js-menu').removeClass('is-open');
			$('.sub-menu').removeClass('is-open');
			$('body').removeClass('menu-open');
		}

		// Lance les animations
		runAnimation();

		if (window.matchMedia('(min-width: 1024px)').matches) {
			$('.js-filter').slideDown();
		}
	});

	$('.js-menu').find('.menu-item-has-children > .menu-link').on('click', function (e) {
		if (window.matchMedia('(max-width: 1024px)').matches) {
			e.preventDefault();

			if ($(this).next('.sub-menu').hasClass('is-open')) {
				$(this).next('.sub-menu').removeClass('is-open');
			} else {
				$(this).next('.sub-menu').addClass('is-open');
			}
		}
	});

	$('.js-open-menu').on('click', function (e) {
		e.preventDefault();

		if ($('.js-menu').hasClass('is-open')) {
			$('.js-menu').removeClass('is-open');
			$('body').removeClass('menu-open');
			$('body').addClass('menu-close');
		} else {
			$('.js-menu').addClass('is-open');
			$('body').addClass('menu-open');
			$('body').removeClass('menu-close');
		}
	});

	$(document).on('click touchstart', function (event) {
		if (!$(event.target).closest('.js-menu').length && !$(event.target).closest('.js-open-menu').length) {
			$('body').removeClass('menu-open');
			$('.js-menu').removeClass('is-open');
		}
	});

	// Menu fixe au scroll
	// *******************************************************************************
	$(document).on('resize scroll', function () {

			var position_scroll = $(window).scrollTop();

			var offset_top_wrapper = $('.page-main').offset().top;
			var height_header = $('.js-header-fixe').height();
			if (position_scroll >= (offset_top_wrapper + height_header)) {
				$('.js-header-fixe').addClass('is-fixed', 300);
			} else {
				$('.js-header-fixe').removeClass('is-fixed', 300);
			}

	});

		// Menu survol
	// *******************************************************************************
	$(".js-menu > .menu-item-has-children").on({
    mouseenter: function () {
			if (window.matchMedia('(min-width: 1024px)').matches) {
        $(this).parents('.site-navigation').addClass('menu-hover');
      }
    },
    mouseleave: function () {
			if (window.matchMedia('(min-width: 1024px)').matches) {
        $(this).parents('.site-navigation').removeClass('menu-hover');
      }
    }
  });

	/* Animation ancre
	*******************************************************************************/
	// $("a[href*='#']:not([href='#']):not(.tabs-link)").click(function () {
	// 	if (location.hostname == this.hostname && this.pathname.replace(/^\//, "") == location.pathname.replace(/^\//, "")) {
	// 		var anchor = $(this.hash);
	// 		anchor = anchor.length ? anchor : $("[name=" + this.hash.slice(1) + "]");
	// 		if (anchor.length) {
	// 			$("html, body").animate({ scrollTop: anchor.offset().top }, 600);
	// 		}
	// 	}
	// });

	/* Show/hide "go top" button
	*******************************************************************************/
	$(document).on('scroll', function () {
		var scroll = $(window).scrollTop();

		if (scroll >= ($(window).height() - 300)) { // Show
			$('.js-scrollTop').addClass('is-visible');
		}
		if (scroll <= ($(window).height() - 300)) { // Hide
			$('.js-scrollTop').removeClass('is-visible');
		}
	});

	// ===============================================================================
	// CONTENU
	// ===============================================================================

	// ===============================================================================
	// ACCORDEON
	// ===============================================================================
	$('.wp-block-pit-accordion-title').on('click', function () {
		$(this).toggleClass('is-open');
		$(this).next('.wp-block-pit-accordion-content').slideToggle();
	})

	// ===============================================================================
	// ANIMATIONS
	// ===============================================================================
	function runAnimation(event) {
		const animate = new IntersectionObserver(function (entries) {
			let delay = 0

			entries.forEach(function (entry) {
				if (entry.intersectionRatio > 0) {
					if ($(entry.target).prev().hasClass('js-animate-item')) {
						delay += 200
						$(entry.target).css('animation-delay', delay + 'ms');
					} else {
						delay = 0
					}

					setTimeout(() => {
						$(entry.target).addClass('is-visible');
					}, 300)
					setTimeout(() => {
						$(entry.target).addClass('is-finish').css('animation-delay', '').dequeue();
					}, delay + 900)
				}
			});
		});

		$('.js-animate-item').each(function () {
			animate.observe(this);
		});
	}

	// ===============================================================================
	// OWL CAROUSEL
	// ===============================================================================
	// if($('.owl-block-customer-promote').length){
	//   $('.owl-block-customer-promote').owlCarousel({
	//     loop: true,
	//     nav: true,
	//     dots: false,
	//     margin: 60,
	//     mouseDrag: false,
	//     autoplay: true,
	//     autoplayHoverPause: true,
	//     responsive : {
	//       0 : {
	//         items: 2
	//       },
	//       640 : {
	//         items: 3
	//       },
	//       1024 : {
	//         items: 6
	//       }
	//     }
	//   });
	// }

	// ===============================================================================
	// FORMULAIRE
	// ===============================================================================

	// Ajout du plugin pour looker les selects
	// *******************************************************************************
	function runSelect() {
		if ($('select').length) {
			$('select').selectric({
				forceRenderBelow: true
			});
		}
	}
	runSelect();

	// ajoute une classe si le champ est rempli pour changer la position du label
	// *******************************************************************************
	function addClassFillField() {
		// au chargement
		$('input, textarea').each(function () {
			if ($(this).val().length > 0) {
				$(this).addClass('is-filled');
			} else {
				$(this).removeClass('is-filled');
			}
		});

		// au changement
		$('input, textarea').on('change', function () {
			if ($(this).val().length > 0) {
				$(this).addClass('is-filled');
			} else {
				$(this).removeClass('is-filled');
			}
		});

		// dans le cas de selectric
		$('select').each(function () {
			if ($(this).val() != '') {
				$(this).parents('.selectric-wrapper').addClass('is-filled');
			}

			$(this).on('selectric-change', function (event, element, selectric) {
				if ($(this).val() != '') {
					$(this).parents('.selectric-wrapper').addClass('is-filled');
				}
			});
		});
	}
	addClassFillField();

	// Permet de mettre en place le style check / pas check sur les radio & checkbox
	// *******************************************************************************
	$(document).on('click', '.frm_checkbox label, .frm_radio label', function () {
		$('input[type="checkbox"]:not(:checked), input[type="radio"]:not(:checked)').parent('label').removeClass('checked');
		$('input[type="checkbox"]:checked, input[type="radio"]:checked').parent().addClass('checked');
	});

	// ===============================================================================
	// AJAX
	// ===============================================================================
	$(document).ajaxComplete(function () {
		// Réinitialiser les librairies
		runSelect();
		runGlightbox();

		// Lance animations
		runAnimation();

		// Ajoute les classes sur les champs remplis
		addClassFillField();
	});

	// ===============================================================================
	// FUNCTIONS
	// ===============================================================================

})(jQuery);
